import { ajaxPostJson,ajaxGetJson,setParams } from './ajax';
// 分页列表数据查询
export const myProjectDataQuery = (params) => {
  params.filter=setParams(params.filter)
  return ajaxPostJson(`/project/queryPage`, params);
};
// 领域下拉框数据查询
export const queryDomain = (params) => {
  return ajaxPostJson(`/project/queryDomainList`, params);
};
// 获取项目数量
export const getTransProjectNum = (params) => {
  return ajaxPostJson(`/project/countTransProjectNum`, params);
};
// 语言对下拉框数据查询
// export const queryLanguage= (params) => {
//   return ajaxPostJson(`/project/queryLangDescList`, params);
// };
export const queryLanguage= (params) => {
  return ajaxPostJson(`/project/queryLangDescAndCodeList`, params);
};
// 删除项目
export const deleteProject= (params) => {
  return ajaxPostJson(`/project/deleteProject`, params);
};
//下载原文、翻译
export const downloadFileList= (url) => {
  return ajaxGetJson(url);
};
// 获取原用户信息
export const olduserInfo = params => {
  return ajaxPostJson(`/user/getOldUserInfo`, params, 'BaseApi')
}

